module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Lost-Treasures-of-the-Maya.fb5485f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Lost-Treasures-of-the-Maya.jpg
// module id = Tprh
// module chunks = 0